module.exports = __webpack_public_path__ + "static/media/README.4cc92051.md";


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-icons/README.md
// module id = 2787
// module chunks = 0